import { render } from "./rouletteGameView.vue?vue&type=template&id=258f07ec&scoped=true"
import script from "./rouletteGameView.vue?vue&type=script&lang=js"
export * from "./rouletteGameView.vue?vue&type=script&lang=js"

import "./rouletteGameView.vue?vue&type=style&index=0&id=258f07ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258f07ec"]])

export default __exports__